import React from 'react'
import MainHeader from "./partials/newheader";    
import Footer from "./partials/footer";
import Offers from './Offers';

export default function Pettipettioffers() {
  return (
    <div>
      <MainHeader />
      <Offers />
      <Footer />
    </div>
  );
}
